define.alias("shared/components/shared/post/secondary/activity/wrapper", "media/components/shared/post/secondary/activity/wrapper");